import { render, staticRenderFns } from "./LimitPriceDia.vue?vue&type=template&id=35d215cc&scoped=true"
import script from "./LimitPriceDia.vue?vue&type=script&lang=js"
export * from "./LimitPriceDia.vue?vue&type=script&lang=js"
import style0 from "./LimitPriceDia.vue?vue&type=style&index=0&id=35d215cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d215cc",
  null
  
)

export default component.exports